import { useEffect } from "react";
import { Skeleton, ErrorPanel } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useGetFleetDriversQuery } from "@/redux/apis/driver/driverApi";
import { useAppSelector } from "@/redux/hooks";
import { FleetSetupSection } from "@/redux/slices/onboarding/types";
import { selectCameFromQuickSetup, selectLastClickedSection } from "@/redux/slices/quickSetup/selectors";
import { useDriversContext } from "../../context";
import { MyDriversTable } from "./MyDriversTable";
import { useGetFleetDriversParams } from "./hooks/useGetFleetDriversParams";

export const MyDriversPanel = () => {
  const { params } = useGetFleetDriversParams();
  const { isFetching, data: response, error } = useGetFleetDriversQuery(params, { refetchOnMountOrArgChange: true });
  const cameFromQuickSetup = useAppSelector(selectCameFromQuickSetup);
  const lastClickedSection = useAppSelector(selectLastClickedSection);
  const { setStep } = useDriversContext();

  useEffect(() => {
    if (cameFromQuickSetup && lastClickedSection === FleetSetupSection.INVITE_OWN_PARTNER_DRIVERS) {
      setStep("invite");
    } else {
      setStep(undefined);
    }
  }, [cameFromQuickSetup, setStep, lastClickedSection]);

  if (error) return <ErrorPanel messages={getErrorMessages(error)} />;
  if (isFetching || !response) return <Skeleton />;

  return (
    <>
      <MyDriversTable items={response.data.drivers} page={response.data.page} />
      <MyDriversTable.Pagination page={response.data.page} />
    </>
  );
};
